import { GameDetailSpec, GameDetailSpecProps, LabelType } from '../gameDetailSpec/GameDetailSpec';

import styles from './GameDetailSpecList.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type GameDetailSpecListProps = {
  specs: GameDetailSpecProps[];
};

export const GameDetailSpecList = ({ specs }: GameDetailSpecListProps) => {
  const { t } = useTranslation();

  return (
    <ul className={styles.container}>
      {specs.map((spec) => {
        const label = t(spec.label);
        if (spec.values && spec.values.length > 0 && !spec.values?.includes('')) {
          return <GameDetailSpec key={spec.label} label={label as LabelType} values={spec.values} />;
        }
        return;
      })}
    </ul>
  );
};
